// extracted by mini-css-extract-plugin
export var blockedMessage = "_8x-3";
export var blockedOverlay = "_8x-1";
export var fadeIn = "_8x-2";
export var hereLink = "_8x-0";
export var slideUp = "_8x-4";